import { c as _c } from "react/compiler-runtime";
import { Typography } from '@components/typography';
import { TrustpilotMicroReviewWidget } from '@components/trustpilot-micro-review-widget';
import { twMerge } from 'tailwind-merge';
interface ListingTrustpilotCardProps {
  className?: string;
}
export const ListingTrustpilotCard = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("flex flex-col items-center gap-1 rounded-xl px-4 py-3 text-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography component="p" className="text-sm font-medium text-primary-main">Savvy is trusted by thousands of travelers</Typography>;
    t3 = <TrustpilotMicroReviewWidget />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};